import type { FC } from "react";

import { Icons } from "widgets";

import { pluralizeWord } from "@/app-utils/string.ts";
import type { Sample } from "@/graphql.ts";
import { StackTile } from "@/modules/core/components/StackTiles";
import { SampleTile } from "@/ui-modules/core/tiles/components/SampleTile.tsx";

interface SamplesStackTileProps {
  samples: Sample[];
}

export const SamplesStackTile: FC<SamplesStackTileProps> = (props) => {
  const tileTitle = `${props.samples.length} ${pluralizeWord("sample", props.samples.length)}`;
  const tileType = props.samples[0].type?.name;
  return props.samples.length === 1 ? (
    <SampleTile sample={props.samples[0]} />
  ) : (
    <StackTile title={tileTitle} type={tileType} icon={<img src={Icons.Tiles.SamplesStack} />}>
      {props.samples.map((sample) => (
        <SampleTile sample={sample} key={sample.id} />
      ))}
    </StackTile>
  );
};
